module.exports = __webpack_public_path__ + "static/media/mason.bec63b70.png";